import React from "react";
import { Button, Card, Input, Spin } from "antd";
import {
  DeleteOutlined,
  LoadingOutlined,
  PaperClipOutlined,
  PlusOutlined,
} from "@ant-design/icons";

const SupportTicketImage = ({
  color,
  selectedImage,
  onClick,
  text,
  iloader,
  isImageUpload,
  onChange,
  screenshot,
}) => {
  return (
    <>
      {isImageUpload && selectedImage ? (
        <div className="ml-4  flex">
          <label htmlFor="imageUpload" className="">
            <Card className="flex flex-col w-20 justify-center items-center bg-white text-primaryPurple group h-[54px] hover:bg-primaryPurple">
              <div className="flex flex-col group-hover:text-white">
                <PaperClipOutlined
                  className="justify-center"
                  style={{ fontSize: "18px" }}
                />
                {screenshot ? "Add Attachment" : "Change Avatar"}
                <Input
                  type="file"
                  id="imageUpload"
                  accept="image/*"
                  className="h-20 w-60"
                  style={{ display: "none" }}
                  onChange={onChange}
                />
              </div>
            </Card>
          </label>
          <div className="relative w-5 h-5 ml-2 flex items-center">
            <DeleteOutlined
              className="hover:cursor-pointer absolute bottom-[35px] left-[35px] p-[2px] bg-white cover-object"
              onClick={onClick}
            />
            <img
              src={selectedImage}
              alt="Selected Image"
              layout="fill"
              objectFit="cover"
              className="rounded-full h-5 w-5 "
            />
          </div>
        </div>
      ) : (
        <div className="ml-4 w-20">
          <label htmlFor="imageUpload" className="">
            <Card className="flex flex-col justify-center items-center bg-white text-primaryPurple group h-[54px] hover:bg-primaryPurple">
              <div className="flex flex-col group-hover:text-white">
                <PaperClipOutlined
                  className="justify-center"
                  style={{ fontSize: "18px" }}
                />
                {screenshot ? "Add Attachment" : "Change Avatar"}
                <Input
                  type="file"
                  id="imageUpload"
                  accept="image/*"
                  className="h-2 w-6"
                  style={{ display: "none" }}
                  onChange={onChange}
                />
              </div>
              <div></div>
            </Card>
          </label>
        </div>
      )}
    </>
  );
};

export default SupportTicketImage;
